import styled from '@emotion/styled';
import { Box, Button, css, Grid, IconButton, Typography } from '@mui/material';
import { colors } from 'theme/colors';

export const StyledSectionWrapper = styled(Grid)`
  border: 1px solid ${colors.primary50};
  border-radius: 4px;
  overflow: hidden;
  margin-top: 8px;
  background-color: ${colors.white};
`;

export const StyledTableHeaderRow = styled(Grid)`
  display: flex;
  background-color: ${colors.primary50};
  border: 1px solid ${colors.primary50};
`;

export const StyledTableHeaderCell = styled(Grid)`
  padding: 6px 12px;
`;

export const StyledFileRow = styled(Grid)`
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid ${colors.primary50};
  &:last-child {
    border-bottom: none;
  }
`;

export const StyledFileCell = styled(Grid)`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 12px 16px;
`;

export const StyledThumbnailWrapper = styled(Box)`
  width: 96px;
  height: 118px;
  flex-shrink: 0;
  border: 1px solid ${colors.gray200};
  border-radius: 3px;
  overflow: hidden;
  background-color: ${colors.gray100};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledThumbnailImage = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const StyledFileInfo = styled(Box)`
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const StyledFileLabel = styled(Typography)`
  font-size: 13px;
  font-weight: 700;
  color: ${colors.gray900};
  margin-bottom: 2px;
`;

export const StyledFileName = styled(Typography)`
  font-size: 13px;
  color: ${colors.gray900};
  font-weight: 400;
  margin-bottom: 8px;
  word-break: break-all;
`;

export const StyledActionsRow = styled(Box)`
  display: flex;
  gap: 2px;
  align-items: center;
`;

export const StyledCommentsCell = styled(Grid)`
  border-left: 1px solid ${colors.gray200};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
`;

export const StyledCommentBox = styled(Box)`
  width: 100%;
  background-color: ${colors.gray100};
  border-radius: 4px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledCommentBoxText = styled(Typography)`
  font-size: 12px;
  font-style: italic;
  color: ${colors.gray500};
  line-height: 1.5;
`;

export const StyledReviewButton = styled(Button)`
  align-self: flex-start;
  font-size: 12px;
  font-weight: 600;
  text-transform: none;
  padding: 4px 12px;
`;
interface IStyledIconWrapper {
  error?: boolean;
}
export const StyledIconWrapper = styled.div<IStyledIconWrapper>`
  width: 24px;
  height: 24px;
  padding: 3.6px;
  border-radius: 4px;
  display: flex;
  justify-content: start;
  align-items: center;
  ${({ error }: IStyledIconWrapper) => css`
    background-color: ${error ? colors.error50 : colors.success50};
  `};
`;
